interface StatisticCardProps {
    imagePath: string
    statistic: string
    unit: string
}

const StatisticCard: React.FC<StatisticCardProps> = ({
    imagePath, statistic, unit
}) => {
    return <>
        <div className="bg-white p-5 shadow-lg flex md:flex-row flex-col gap-5 rounded-xl">
            <div className="lg:px-4 px-1">
                <img src={imagePath} alt="" className="w-full"/>
            </div>
            <div className="flex flex-col justify-center">
                <p className="text-xl lg:text-3xl font-bold">{statistic}</p>
                <p className="text-sm lg:text-lg text-gray-nor">{unit}</p>
            </div>
        </div>
    </>
}

export default StatisticCard